// import React, { useEffect, useState } from "react";
// import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// import circleImage from "../assets/images/circleIcon.png"; // Replace with your actual icon path
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import validatePhotoThumbAndSignData from "../utilities/validatePhotoThumbAndSignData";
// import { updateUser } from "../redux-store/slices/partyDetailsSlice";
// import API_BASE_URL from "../utilities/ApiConfig";

// const CommissionDetailsModal = ({
//   onClose,
//   onProceed,
//   tokenDate,
//   tokenNo,
//   bookNo,
// }) => {
//   const location = useLocation();
//   const { userDetails } = useSelector((state) => state.auth);

//   debugger;
//   const dcode = userDetails?.dcode;
//   const srocode = userDetails?.srocode;
//   const [applicationDate, setApplicationDate] = useState("");
//   const [volume, setVolume] = useState("");
//   const [srNo, setSrNo] = useState("");
//   const [partyType, setPartyType] = useState("");
//   const [selectedOption, setSelectedOption] = useState("");
//   const [commissionAddress, setCommissionAddress] = useState("");
//   const [volumeOptions, setVolumeOptions] = useState([]); // Dynamic volume options
//   const [SrNoOptions, setSrNoOptions] = useState([]);
//   const [appName, setAppName] = useState(""); // Store fetched appname
//   const [partyOptions, setPartyOptions] = useState([]);

//   useEffect(() => {
//     if (applicationDate) {
//       fetchVolumeOptions();
//     }
//   }, [applicationDate]);

//   const fetchVolumeOptions = async () => {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/CommissionDetails/get_commission_volume/${dcode}/${srocode}?recptdate=${applicationDate}`
//       );

//       if (response.data) {
//         setVolumeOptions(response.data); // Assuming the API returns an array of volumes
//       }
//     } catch (error) {
//       console.error("Error fetching volume options:", error);
//     }
//   };

//   useEffect(() => {
//     if (volume) {
//       fetchSrNoOptions();
//     }
//   }, [volume]);

//   const fetchSrNoOptions = async () => {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/CommissionDetails/get_commission_srno/${dcode}/${srocode}?recptdate=${applicationDate}&VolNo=${volume}`
//       );

//       if (response.data) {
//         setSrNoOptions(response.data); // Assuming the API returns an array of volumes
//       }
//     } catch (error) {
//       console.error("Error fetching volume options:", error);
//     }
//   };

//   useEffect(() => {
//     if (volume && srNo) {
//       fetchAppName();
//     }
//   }, [volume, srNo]);

//   const fetchAppName = async () => {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/CommissionDetails/get_commission_AppName/${dcode}/${srocode}?recptdate=${applicationDate}&VolNo=${volume}&SrNo=${srNo}`
//       );
//       if (response.data.length > 0) {
//         setAppName(response.data[0]); // Assuming API returns an array with one appname
//       } else {
//         setAppName(""); // Clear if no data found
//       }
//     } catch (error) {
//       console.error("Error fetching app name:", error);
//       setAppName("");
//     }
//   };

//   useEffect(() => {
//     debugger;
//     if (partyType) {
//       fetchPartyOption();
//     }
//   }, [partyType]);
//   const fetchPartyOption = async () => {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/CommissionDetails/get_commission_party_name/${dcode}/${srocode}?tokendate=${tokenDate}&tokenno=${tokenNo}&bookno=${bookNo}&mode=${partyType}`
//       );

//       if (response.data.statusCode === 200) {
//         setPartyOptions(response.data.partyNames); // Store the entire array
//       } else {
//         setPartyOptions([]); // Empty array if no data
//       }
//     } catch (error) {
//       console.error("Error fetching party options:", error);
//       setPartyOptions([]);
//     }
//   };

//   const handleProceed = () => {
//     const formData = {
//       applicationDate,
//       volume,
//       srNo,
//       appName,
//       partyType,
//       selectedOption,
//       commissionAddress,
//     };

//     console.log("Sending modal data:", formData);
//     onProceed(formData); // Call parent function with data
//     onClose(); // Close modal
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary-black bg-opacity-50">
//       <div className="bg-white w-full max-w-3xl relative rounded-lg shadow-lg">
//         {/* Header */}
//         <div className="relative bg-[#CAE5FF] px-4 py-2 flex items-center justify-between border-b-4 border-[#3A8FF6]">
//           <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-md">
//             <img src={circleImage} alt="Circle Icon" className="h-12 w-12" />
//           </div>
//           <h2 className="text-lg font-semibold ml-4">Commission Details</h2>
//           <button
//             onClick={onClose}
//             className="text-secondary-600 hover:text-secondary-900"
//           >
//             <CloseOutlinedIcon />
//           </button>
//         </div>

//         {/* Content */}
//         <div className="p-6">
//           {/* Application Date, Volume & Sr. No. */}
//           <div className="grid grid-cols-4 gap-4">
//             {/* Application Date */}
//             <div className="grid grid-cols-3 col-span-2 items-center gap-2">
//               <label className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
//                 Application Date:
//               </label>
//               <input
//                 type="date"
//                 value={applicationDate}
//                 onChange={(e) => setApplicationDate(e.target.value)}
//                 className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
//               />
//             </div>

//             {/* Volume Dropdown */}
//             <div className="grid grid-cols-2 items-center gap-2">
//               <label className="text-sm font-medium">Vol:</label>
//               <select
//                 className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//                 value={volume}
//                 onChange={(e) => setVolume(e.target.value)}
//               >
//                 <option value="">Select</option>
//                 {volumeOptions.map((vol) => (
//                   <option key={vol} value={vol}>
//                     {vol}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Serial Dropdown */}
//             <div className="grid grid-cols-2 items-center gap-2">
//               <label className="text-sm font-medium">Sr:</label>
//               <select
//                 className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//                 value={srNo}
//                 onChange={(e) => setSrNo(e.target.value)}
//               >
//                 <option value="">Select</option>
//                 {SrNoOptions.map((sr) => (
//                   <option key={sr} value={sr}>
//                     {sr}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Input Field */}
//           <input
//             type="text"
//             className="w-full mt-4 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//             placeholder="App Name"
//             value={appName} // Bind the fetched appname
//             readOnly // Make it non-editable
//           />

//           {/* Party Type Selection */}
//           <p className="mt-4 font-semibold">Select Party Type:</p>
//           <div className="flex gap-4 mt-2">
//             <label className="flex items-center">
//               <input
//                 type="radio"
//                 name="partyType"
//                 value="First Party"
//                 checked={partyType === "First Party"}
//                 onChange={() => {
//                   setPartyType("First Party");
//                   setSelectedOption(""); // Reset dropdown when switching
//                 }}
//                 className="mr-2"
//               />
//               First Party
//             </label>
//             <label className="flex items-center">
//               <input
//                 type="radio"
//                 name="partyType"
//                 value="Second Party"
//                 checked={partyType === "Second Party"}
//                 onChange={() => {
//                   setPartyType("Second Party");
//                   setSelectedOption(""); // Reset dropdown when switching
//                 }}
//                 className="mr-2"
//               />
//               Second Party
//             </label>
//           </div>

//           {/* Dropdown Selection */}

//           <select
//             className="w-full mt-4 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//             value={selectedOption}
//             onChange={(e) => setSelectedOption(e.target.value)}
//             disabled={!partyType} // Disable dropdown until party type is selected
//           >
//             <option value="">Select</option>
//             {partyOptions.map((option, index) => (
//               <option key={index} value={option.pCode}>
//                 {option.nameHin}
//               </option>
//             ))}
//           </select>

//           {/* Commission Address */}
//           <textarea
//             className="w-full mt-4 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//             rows="3"
//             placeholder="Commission Address"
//             value={commissionAddress}
//             onChange={(e) => setCommissionAddress(e.target.value)}
//           ></textarea>

//           {/* Buttons */}
//           <div className="flex justify-center gap-4 mt-6">
//             <button
//               onClick={handleProceed}
//               className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium"
//             >
//               Proceed
//             </button>
//             <button
//               onClick={onClose}
//               className="border border-red-500 text-red-500 px-6 py-2 rounded-full text-sm font-medium hover:bg-red-100"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CommissionDetailsModal;

import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import circleImage from "../assets/images/circleIcon.png"; // Replace with your actual icon path
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useLocation } from "react-router-dom";
import API_BASE_URL from "../utilities/ApiConfig";

const CommissionDetailsModal = ({
  onClose,
  onProceed,
  tokenDate,
  tokenNo,
  bookNo,
}) => {
  const location = useLocation();
  const { userDetails } = useSelector((state) => state.auth);

  const dcode = userDetails?.dcode;
  const srocode = userDetails?.srocode;
  const [applicationDate, setApplicationDate] = useState("");
  const [volume, setVolume] = useState("");
  const [srNo, setSrNo] = useState("");
  const [partyType, setPartyType] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [commissionAddress, setCommissionAddress] = useState("");
  const [volumeOptions, setVolumeOptions] = useState([]);
  const [SrNoOptions, setSrNoOptions] = useState([]);
  const [appName, setAppName] = useState("");
  const [partyOptions, setPartyOptions] = useState([]);

  useEffect(() => {
    if (applicationDate) {
      fetchVolumeOptions();
    }
  }, [applicationDate]);

  const fetchVolumeOptions = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CommissionDetails/get_commission_volume/${dcode}/${srocode}?recptdate=${applicationDate}`
      );
      if (response.data) {
        setVolumeOptions(response.data);
      }
    } catch (error) {
      console.error("Error fetching volume options:", error);
    }
  };

  useEffect(() => {
    if (volume) {
      fetchSrNoOptions();
    }
  }, [volume]);

  const fetchSrNoOptions = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CommissionDetails/get_commission_srno/${dcode}/${srocode}?recptdate=${applicationDate}&VolNo=${volume}`
      );
      if (response.data) {
        setSrNoOptions(response.data);
      }
    } catch (error) {
      console.error("Error fetching volume options:", error);
    }
  };

  useEffect(() => {
    if (volume && srNo) {
      fetchAppName();
    }
  }, [volume, srNo]);

  const fetchAppName = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CommissionDetails/get_commission_AppName/${dcode}/${srocode}?recptdate=${applicationDate}&VolNo=${volume}&SrNo=${srNo}`
      );
      if (response.data.length > 0) {
        setAppName(response.data[0]);
      } else {
        setAppName("");
      }
    } catch (error) {
      console.error("Error fetching app name:", error);
      setAppName("");
    }
  };

  const handleProceed = () => {
    const formData = {
      applicationDate,
      volume,
      srNo,
      appName,
      partyType,
      selectedOption,
      commissionAddress,
    };
    console.log("Sending modal data:", formData);
    onProceed(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary-black bg-opacity-50">
      <div className="bg-white w-full max-w-3xl relative rounded-lg shadow-lg">
        <div className="relative bg-[#CAE5FF] px-4 py-2 flex items-center justify-between border-b-4 border-[#3A8FF6]">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-md">
            <img src={circleImage} alt="Circle Icon" className="h-12 w-12" />
          </div>
          <h2 className="text-lg font-semibold ml-4">Commission Details</h2>
          <button
            onClick={onClose}
            className="text-secondary-600 hover:text-secondary-900"
          >
            <CloseOutlinedIcon />
          </button>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-2 gap-4">
            <div className="relative">
              <input
                type="date"
                value={applicationDate}
                onChange={(e) => setApplicationDate(e.target.value)}
                className="w-full h-10 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer"
                placeholder=" "
              />
              <label className="floating-label">Application Date</label>
            </div>
            <div className="relative">
              <select
                className="w-full h-10 border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500 peer"
                value={volume}
                onChange={(e) => setVolume(e.target.value)}
              >
                <option value="">Select Volume</option>
                {volumeOptions.map((vol) => (
                  <option key={vol} value={vol}>
                    {vol}
                  </option>
                ))}
              </select>
              <label className="floating-label">Volume</label>
            </div>
          </div>
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={handleProceed}
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium"
            >
              Proceed
            </button>
            <button
              onClick={onClose}
              className="border border-red-500 text-red-500 px-6 py-2 rounded-full text-sm font-medium hover:bg-red-100"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommissionDetailsModal;
